let _ = t => t,
  _t;
import { useEffect } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import styledWithTheme from 'foundations-theming/utils';
import { View } from 'foundations-components/components/View';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { BREAKPOINTS } from 'foundations-components/transitional/components/Grid';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledPanel = styledWithTheme.div(_t || (_t = _`
  position: fixed;
  background-color: ${0};
  inset: 0;
  z-index: 1111;
  contain: content;
  transform: ${0};
  transition: transform 0.3s ease;
  overflow-y: scroll;

  @media (min-width: ${0}px) {
   inset-block-start: ${0};
   inset-inline-start: ${0};
 }
`), ({
  theme
}) => theme.color['fill-surface-default'], ({
  isOpen
}) => isOpen ? 'translateY(0)' : 'translateY(100%)', BREAKPOINTS.sm + 1, ({
  theme
}) => theme.space['1000'], ({
  theme
}) => theme.space['1300']);
export const FullScreenPanel = ({
  children,
  'data-test-id': dataTestId,
  isOpen,
  onRemoveButtonClick,
  title
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return /*#__PURE__*/_jsxs(StyledPanel, {
    "data-test-id": dataTestId,
    isOpen: isOpen,
    role: "dialog",
    "data-test-is-open": isOpen,
    children: [/*#__PURE__*/_jsxs(Flex, {
      justifyContent: title ? 'space-between' : 'end',
      padding: "400",
      position: "sticky",
      insetBlockStart: "0",
      backgroundColor: "fill-surface-default",
      zIndex: 1,
      borderBlockEndColor: "border-core-default",
      borderBlockEndStyle: "solid",
      borderBlockEndWidth: "100",
      children: [title, /*#__PURE__*/_jsx(IconButton, {
        "data-test-id": "close-button",
        onClick: onRemoveButtonClick,
        use: "unstyled",
        children: /*#__PURE__*/_jsx(RemoveIcon, {})
      })]
    }), /*#__PURE__*/_jsx(View, {
      paddingBlockStart: "600",
      paddingInline: "1000",
      children: children
    })]
  });
};